import { actionType } from './action';
import { IAction } from '@interface/IAction';

export const InitialState = Object.freeze({
    funderStatementPath: ''
});


const reducer = (preState = InitialState, action: IAction) => {
    const { type, payload } = action;

    switch (type) {

        case actionType.SET_PRE_SIGNED_FUNDER_STATEMENT_URL:
            return {
                ...preState,
                funderStatementPath: payload
            };

        default:
            return preState;
    }
}

export default reducer;